import * as S from "./planCard.style";
import Container from "~/components/ui/Container";
import Separator from "~/components/ui/Separator";
import { SVG } from "~/components/ui/SVG";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { SVGIcon } from "~/components/ui/SVG/types";
import { IPlan, SubscriptionType } from "~/types/billing";
import { centsToDecimal } from "~/helpers/numbers";
import { usePlan } from "~/contexts/Plans";
import RadioButton from "~/components/common/RadioButton";
import { useMediaQuery } from "~/hooks/useMediaQuery";
//@ts-ignore
import { ReactComponent as CircleCheck } from "~/assets/svg/circle-check.svg";

type Props = {
  plan?: IPlan;
  setSelectedPlanId?: (id: string | undefined) => void;
  selectedPlanId?: string;
  isLaptop?: boolean;
};

export const isFeatureCrossedOff = (feature: string) => {
  return feature.includes("<s>") && feature.includes("</s>");
};

const PlanCard = ({ plan, selectedPlanId, setSelectedPlanId }: Props) => {
  if (!plan) return null;

  const { setPlan } = usePlan();
  const isLaptop = useMediaQuery("laptop");

  const {
    name,
    cost_per_month: costPerMonth,
    features,
    interval,
    is_highlighted: isHighlighted,
    months_off: monthsOff,
    id,
  } = plan;

  const isAnnual = interval === SubscriptionType.ANNUAL;

  const setCurrentPlan = (planId?: string) => {
    //@ts-ignore
    setSelectedPlanId(planId);
    setPlan(plan);
  };

  const separateCentsFromNumber = (priceCents: number) => {
    const splitAt = (index: number, xs: string) => [
      xs.slice(0, index),
      xs.slice(index),
    ];
    const stringPriceCents = priceCents.toString();
    const length = stringPriceCents.length;
    const separatedPrice = splitAt(length - 3, stringPriceCents);
    return separatedPrice;
  };

  return (
    <S.PlanCardContainer
      primary={isHighlighted}
      active={id === selectedPlanId}
      onClick={() => setCurrentPlan(id)}
    >
      {isAnnual || isHighlighted ? (
        <S.PlanCardPromotion isHighlighted={isHighlighted}>
          {isAnnual ? (
            <S.MonthsOffText>{`${monthsOff} months off`}</S.MonthsOffText>
          ) : (
            isHighlighted && (
              <S.MostPopularText>🔥 Most Popular</S.MostPopularText>
            )
          )}
        </S.PlanCardPromotion>
      ) : null}

      <Container padding={0} justifyContent="space-between">
        <S.RadioPlanName>
          <RadioButton
            onChange={() => {
              setCurrentPlan(id);
            }}
            checked={id === selectedPlanId}
          />
          <S.PlanCardTitle active={id === selectedPlanId}>
            {name}
          </S.PlanCardTitle>
        </S.RadioPlanName>
        <S.PlanCardPrice active={id === selectedPlanId}>
          {isAnnual ? (
            <>{`$${centsToDecimal(costPerMonth)}/mon`}</>
          ) : (
            <>
              {`$${separateCentsFromNumber(centsToDecimal(costPerMonth))[0]}`}
              <sub>{`${
                separateCentsFromNumber(centsToDecimal(costPerMonth))[1]
              }/mon`}</sub>
            </>
          )}
        </S.PlanCardPrice>
      </Container>
      <Separator type="horizontal" />
      <S.PlanCardList isLaptop={isLaptop}>
        {features.map((feature: any, index: number) => (
          <S.PlanCardItem
            key={String(feature+index)}
          >
            <CircleCheck />
            <span
              dangerouslySetInnerHTML={{ __html: feature }}
            />
          </S.PlanCardItem>
        ))}
      </S.PlanCardList>
    </S.PlanCardContainer>
  );
};

export default PlanCard;
